import { showNotification } from "@shared/store/actions";
import { bytesToMegaBytes } from "@shared/utils";
import React, { useCallback, useMemo, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch } from "react-redux";

import "./index.scss";

interface DragDropProps {
  types?: string[];
  onUploadFile: (file: File | null) => void;
  maxFileSize?: number; //MB
}

function DragDrop(props: DragDropProps) {
  const { types, onUploadFile, maxFileSize } = props;
  const dispatch = useDispatch();

  const [file, setFile] = useState<File | null>(null);
  const [fileError, setFileError] = useState<string | null>(null);

  const allowedTypesText = useMemo(() => {
    if (!types) return "";
    return types.join(", ").toUpperCase();
  }, [types]);

  const handleChange = useCallback(
    (file: File | null) => {
      setFileError(null);

      if (file && maxFileSize && maxFileSize < bytesToMegaBytes(file.size)) {
        dispatch(
          showNotification({
            message: `The file size exceeds the maximum limit of ${maxFileSize} MB.`,
            appearance: "error",
          }),
        );
        return;
      }

      setFile(file);
      onUploadFile(file);
    },
    [dispatch, onUploadFile, maxFileSize],
  );

  return (
    <div>
      <FileUploader handleChange={handleChange} name="file" types={types} fileOrFiles={file} onTypeError={setFileError}>
        <div className="upload-file-zone">
          {fileError ? (
            <div className="file-error">
              <div>{fileError}</div>
              {allowedTypesText ? <div>Please upload {allowedTypesText} format</div> : null}
            </div>
          ) : file ? (
            <div>Upload another?</div>
          ) : (
            <div>{`Upload or drop a file right here (${allowedTypesText})`}</div>
          )}
        </div>
      </FileUploader>
      {file ? (
        <div className="selected-file">
          <div className="file-name">{file.name}</div>
          <div className="file-remove" onClick={() => handleChange(null)}>
            X
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default DragDrop;
